"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const RewardDefinition_1 = require("./RewardDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    script: zod_1.z.string((0, validation_1.labelZodErrors)("Script")).min(1, "QuestScript is required."),
});
const dataSchema = zod_1.z.object({
    response: zod_1.z.unknown(),
});
exports.default = new RewardDefinition_1.RewardDefinition("RUN_QUEST_SCRIPT", configSchema, dataSchema, new validation_1.ValidatorPipeline("RunQuestScript", [
    // TODO: Parse out @UseApp and require those apps are linked.
    // TODO: Ensure script is valid and executable
    (0, validation_1.createZodSchemaValidator)(["config"], configSchema),
]), validation_1.NO_OP_VALIDATOR);
//# sourceMappingURL=RUN_QUEST_SCRIPT.js.map